const nonUnionDaily = termsV2 => {
  return {
    rate_per_day_studio: termsV2?.rate || null,
  };
};

export default nonUnionDaily;
